import {
  Component,
  OnInit, OnDestroy, inject, ViewChildren, QueryList
} from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NavTabService } from '../../services/nav-tab.service';
import { MatTabsModule, MatTabChangeEvent } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { NavigationComponent } from '../navigation/navigation.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Subscription } from 'rxjs';
import { MatMenuModule } from '@angular/material/menu';
import { AuthService } from '../../services/auth.service';
import { Tab } from '../../shared/interfaces/tab.interface';
import { TabHostComponent } from './tab-host.component';
import { ScreenSizeService } from '../../services/screen-size.service';
import { QuickLinksComponent } from '../quick-links/quick-links.component';
import { map, shareReplay } from 'rxjs/operators';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { NotificationsComponent } from '../notifications/notifications.component';
import { RtsCreatorService } from '../../services/rts-creator.service';
import { QuickTicketComponent } from '../../components/royal-ticketing/quick-ticket.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    CommonModule,
    MatTabsModule,
    MatIconModule,
    MatButtonModule,
    NavigationComponent,
    MatSidenavModule,
    MatToolbarModule,
    MatMenuModule,
    TabHostComponent,
    QuickLinksComponent,
    NotificationsComponent,
    QuickTicketComponent
  ],
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  createTicket(): void {
    this.ticketCreator.open();
  }
  @ViewChildren(TabHostComponent) private tabHosts!: QueryList<TabHostComponent>;

  refreshActiveTab(): void {
    this.tabHosts.find(host => host.active)?.refresh();
  }

  tabs: Tab[] = [];
  selectedTabIndex = 0;
  image: string = '';
  fullName: string = '';
  email: string = '';
  isLaptop = false;
  appScale = 1;
  ngOnDestroy(): void { this.subscriptions.forEach(subscription => subscription.unsubscribe()); }
  private subscriptions: Subscription[] = [];
  private bp = inject(BreakpointObserver);

  constructor(
    public navTabService: NavTabService,
    private authService: AuthService,
    private ticketCreator: RtsCreatorService,
    public sanitizer: DomSanitizer,
    public screenSizeService: ScreenSizeService,
  ) { }

  getImageSrc(base64: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(base64);
  }

  ngOnInit() {

    this.subscriptions.push(this.screenSizeService.isLaptop$.subscribe(isLaptop => {
      this.isLaptop = isLaptop;
    }));
    this.subscriptions.push(this.screenSizeService.appScale$
      .subscribe(scale => {
        this.appScale = scale;
      }));
    this.authService.image$.subscribe(image => this.image = image);
    this.authService.fullName$.subscribe(name => this.fullName = name);
    this.authService.email$.subscribe(email => this.email = email);    
    this.image = localStorage['image'];
    this.fullName = localStorage['displayName'];
    this.email = localStorage['email'];

    this.subscriptions.push(
      this.navTabService.tabs$.subscribe((tabs) => {
        this.tabs = tabs;
      }),
      this.navTabService.selectedTab$.subscribe((index) => {
        this.selectedTabIndex = index;
      })
    );
  }

  selectTab(event: MatTabChangeEvent) {
    this.navTabService.setSelectedTab(event.index);
  }

  closeTab(index: number) {
    if (index === 0) return; // prevent dashboard tab from being closed
    this.navTabService.removeTab(index);
  }

  closeRelated(index:number, mode:'others'|'right') {
    const targets=this.tabs.map((_,i)=>i).filter(i=>i>0 && (mode==='others'?i!==index:i>index));
    if(!targets.length || !window.confirm(`Close ${targets.length} tabs? Unsaved changes in those screens will be lost.`)) return;
    for(const i of targets.reverse()) this.navTabService.removeTab(i);
  }

  onLogout() {
    this.authService.logout();
  }
}
